<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-user-edit"></i> <ng-container i18n>Edit Guest</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        <h6 i18n>Change the guest on this booking:</h6>
      </div>

      <div class="col-md-12">
        <app-select-search
          bindLabel="label"
          bindValue="id"
          [inline]="false"
          (search)="guestSearch.next($event)"
          [multiple]="false"
          [items]="guests$ | async"
          [ctrl]="form.get('guestId')"
          i18n-placeholder
          placeholder="Change Guest"
        ></app-select-search>
      </div>
    </div>
  </form>
  <hr />
  <form [formGroup]="guestForm">
    <div class="row">
      <div class="col-md-12">
        <h6 i18n>Edit the current guest information:</h6>
      </div>

      <div class="col-md-12">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            placeholder="Guest Email"
            matInput
            i18n-placeholder
            formControlName="email"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let email of emails" [value]="email.email">
              {{ email.email }} <span *ngIf="email.primary" i18n>(Primary)</span>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="guestForm.get('email').touched && guestForm.get('email').hasError('required')">
            <ng-container i18n>Guest email is required</ng-container>
          </mat-error>
          <mat-error
            *ngIf="
              guestForm.get('email').touched &&
              (guestForm.get('email').hasError('pattern') || guestForm.get('email').hasError('email'))
            "
          >
            <ng-container i18n>Please enter a valid email address</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-12">
        <mat-form-field2 class="mat-block">
          <input type="text" formControlName="name" matInput required i18n-placeholder placeholder="Name" />
          <mat-error *ngIf="guestForm.get('name').touched && guestForm.get('name').hasError('required')">
            <ng-container i18n>Guest name is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>

      <div class="col-md-6" formGroupName="address">
        <mat-form-field2 class="mat-block">
          <input type="text" formControlName="city" matInput i18n-placeholder placeholder="City" />
        </mat-form-field2>
      </div>

      <div class="col-md-6">
        <app-country-select
          [nameCtrl]="guestForm.get('address').get('country')"
          [codeCtrl]="guestForm.get('address').get('country_code')"
        ></app-country-select>
      </div>
      <div class="col-md-6">
        <app-phone-number-input [ctrl]="guestForm.get('phone')" [showPrefix]="true"></app-phone-number-input>
      </div>
      <div class="col-md-6">
        <div class="position-relative">
          <a
            href="javascript:;"
            (click)="onSendWhatsappMessage()"
            *ngIf="!!guestForm.get('whatsapp_phone').value"
            class="position-absolute"
            style="right: 0; z-index: 1"
            i18n
            >Send Message</a
          >
          <app-phone-number-input
            [ctrl]="guestForm.get('whatsapp_phone')"
            prefixIcon="fab fa-whatsapp text-lg text-whatsapp"
            [showPrefix]="true"
            i18n-hint
            hint="WhatsApp message is free!"
            i18n-placeholder
            placeholder="WhatsApp Number"
          ></app-phone-number-input>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(guestForm)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
